// extracted by mini-css-extract-plugin
module.exports = {"w1e94j7f":"w1e94j7f","s1kx9sj8":"s1kx9sj8","e8hvz8q":"e8hvz8q","spin":"spin","p1nu4rzr":"p1nu4rzr"};